export interface PricingDetails {
    action?: string;
    message?: string;
    translatedMessage?: string;
    finalPrice?: string;
    secondBestPrice?: string;
    userPrice?: string;
    pricingCurrencyCode?: string;
    onlinePriceApplicable?: boolean;
    error?: boolean;
    priceRuleType?: string;
    formattedPrice?: {
        finalPrice?: string;
        userPrice?: string;
        absoluteSavings?: string;
        listPrice?: string;
        yourPrice?: string;
        onlinePrice?: string;
        specialOffer?: string;
    }
    secondBestPriceType?: string;
    specialOfferEndDate?: string;
}

export class PricingDetailsModel implements PricingDetails {
    action = null;
    message = null;
    translatedMessage = null;
    finalPrice = null;
    secondBestPrice = null;
    userPrice = null;
    pricingCurrencyCode = null;
    onlinePriceApplicable = false;
    priceRuleType = 'LIST'; // Can be: LIST, SPECIALOFFER, ONLINE - missing how to map ACCOUNT
    formattedPrice = {    };
    secondBestPriceType = null;
    specialOfferEndDate = null;
    error: boolean = false;

    constructor(data?: PricingDetails) {

        if (data?.action) {
            this.action = data.action;
        }

        if (data?.message) {
            this.message = data.message;
        }

        if (data?.translatedMessage) {
            this.translatedMessage = data.translatedMessage;
        }

        if (data?.finalPrice) {
            this.finalPrice = data.finalPrice;
        }

        if (data?.secondBestPrice) {
            this.secondBestPrice = data.secondBestPrice;
        }

        if (data?.userPrice) {
            this.userPrice = data.userPrice;
        }

        if (data?.pricingCurrencyCode) {
            this.pricingCurrencyCode = data.pricingCurrencyCode;
        }

        if (data?.error) {
            this.error = data.error;
        }

        if (data?.priceRuleType) {
            this.priceRuleType = data.priceRuleType;
        }

        if (data?.onlinePriceApplicable) {
            this.onlinePriceApplicable = data.onlinePriceApplicable;
        }

        if (data?.formattedPrice) {
            this.formattedPrice = data.formattedPrice;
        }

        if (data?.secondBestPriceType) {
            this.secondBestPriceType = data.secondBestPriceType;
        }

        if (data?.specialOfferEndDate) {
            this.specialOfferEndDate = data.specialOfferEndDate;
        }

    }
}
